import type { ExperimentConfig } from './types';

export const STATIC_EXPERIMENTS: ExperimentConfig[] = [];

const pagesWithDuplicatedExperiments: { [page: string]: string[] } = {};

export const STATIC_EXPERIMENT_CONFIG = STATIC_EXPERIMENTS.reduce(
  (experimentConfig: Record<string, string>, experiment, index) => {
    const experimentPages = experiment.paths;

    experimentPages.forEach(experimentPage => {
      // Searching for duplicated experiments
      const existingExperimentOnPage = experimentConfig[experimentPage];
      if (existingExperimentOnPage) {
        if (!pagesWithDuplicatedExperiments[experimentPage]) {
          pagesWithDuplicatedExperiments[experimentPage] = [existingExperimentOnPage];
        }
        pagesWithDuplicatedExperiments[experimentPage].push(experiment.name);
      }
      // End searching for duplicated experiments

      experimentConfig[experimentPage] = experiment.name;
    });

    // Forcing failure if more than one static experiment per page is found
    if (
      index === STATIC_EXPERIMENTS.length - 1 &&
      Object.keys(pagesWithDuplicatedExperiments).length > 0
    ) {
      const errorFriendlyObject = Object.keys(pagesWithDuplicatedExperiments).reduce(
        (acc: Record<string, string>, key) => {
          acc[key] = pagesWithDuplicatedExperiments[key].join(' | ');
          return acc;
        },
        {},
      );
      throw new Error('There can only be one static experiment per page', {
        cause: JSON.stringify(errorFriendlyObject),
      });
    }

    return experimentConfig;
  },
  {},
);
